import React from "react";

import Link from "shared/Link";
import Loader from "shared/Loader";
import { Section, Row, Column, LabelGroup } from "shared/layout";
import { useAuthedRequest } from "shared/@auth/Auth";

export default function Amway({ iboNumber }) {
  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/amway/${iboNumber}`
  );

  // {
  //   "ibo_number": "1478107",
  //   "status": "Active",
  //   "payment_eligible": "Yes",
  //   "consent_provided": "Yes",
  //   "application_date": "1989-10-27",
  //   "message": ""
  // }

  return (
    <div>
      {data == null && loading ? (
        <Loader />
      ) : data == null || error != null ? (
        <span>No Amway record found.</span>
      ) : (
        <div>
          <Section>
            <Row>
              <Column>
                <LabelGroup title="IBO Number">
                  {String(data.ibo_number) !== String(iboNumber) ? (
                    <Link to={getMemberUrl(data.ibo_number)}>
                      {data.ibo_number}
                    </Link>
                  ) : (
                    data.ibo_number
                  )}
                </LabelGroup>
                <LabelGroup title="Status">{data.status}</LabelGroup>
              </Column>
              <Column>
                <LabelGroup title="Payment Eligible">
                  {data.payment_eligible}
                </LabelGroup>
                <LabelGroup title="Consent Provided">
                  {data.consent_provided}
                </LabelGroup>
                <LabelGroup title="Application Date">
                  {data.application_date}
                </LabelGroup>
                <LabelGroup title="Additional Notes">
                  {data.message.length > 0 ? data.message.length : "None"}
                </LabelGroup>
              </Column>
            </Row>
          </Section>
        </div>
      )}
    </div>
  );
}

function getMemberUrl(iboNumber) {
  return `/membership/lookup/ibo/${iboNumber}`;
}
